import React from "react";
import { Button } from "reactstrap";
import actionVerticleDots from "../Trips/assets/more-vertical.png";


export const actions = (actionString, ele, routingToIndentData) => {
  // console.log(actionString, "--- status");
  var darkMode = document.body.classList.contains('dark__mode');
  let authUser = JSON.parse(localStorage.getItem("authUser"));
  let userEmail = authUser?.data?.email;
  
  // Get allowed emails from environment variable
  const allowedEmails = process.env.REACT_APP_ADMIN_EMAILS 
    ? process.env.REACT_APP_ADMIN_EMAILS.split(',').map(email => email.trim())
    : [];
  
  // Check if user email matches any of the allowed emails
  const canCancel = userEmail && allowedEmails.includes(userEmail);
  // console.log("darkMode",darkMode);
  switch (actionString) {
    case "Accepted":
      return (
        <div className="dropdown ">
          <Button className="iconButtons dropbtn actionButtonsDark">
            <img
              style={{ margin: "-4px" }}
              src={actionVerticleDots}
              alt="actions"
            />
          </Button>
          <div className="dropdown-content contentDark">
            <div
              className="action-button actionDspan"
              onClick={() => {
                routingToIndentData.routingToProvideDetailModel(ele);
              }}
            >
              Provide Details
            </div>
             {/* {darkMode?<hr className="actionLine"></hr>:""} */}
            {canCancel && (
              <div
                className="action-button-cancel"
                onClick={() => {
                  routingToIndentData.routingToCancelIndentModel(ele);
                }}
              >
                Cancel
              </div>
            )}
            <div
              className="action-button actionDspan"
              onClick={() => {
                routingToIndentData.routingToIndentDataModel(ele);
              }}
            >
              Details
            </div>
          </div>
        </div>
      );
    case "Rejected":
      return (
        <div className="dropdown">
          <Button className="iconButtons dropbtn actionButtonsDark">
            <img
              style={{ margin: "-4px" }}
              src={actionVerticleDots}
              alt="actions"
            />
          </Button>
          <div className="dropdown-content contentDark">
            <div className="action-button actionDspan"
            onClick={() => {
              routingToIndentData.routingToDraftToFinal(ele);
            }}
            >Edit Details</div>
            {canCancel && (
              <div
                className="action-button-cancel"
                onClick={() => {
                  routingToIndentData.routingToCancelIndentModel(ele);
                }}
              >
                Cancel
              </div>
            )}
            <div
              className="action-button actionDspan"
              onClick={() => {
                routingToIndentData.routingToIndentDataModel(ele);
              }}
            >
              Details
            </div>
          </div>
        </div>
      );
    case "AutoRejected":
      return (
        <div className="dropdown">
          <Button className="iconButtons dropbtn actionButtonsDark">
            <img
              style={{ margin: "-4px" }}
              src={actionVerticleDots}
              alt="actions"
            />
          </Button>
          <div className="dropdown-content contentDark">
          <div className="action-button actionDspan"
            onClick={() => {
              routingToIndentData.routingToDraftToFinal(ele);
            }}
            >Edit Details</div>
            {canCancel && (
              <div
                className="action-button-cancel"
                onClick={() => {
                  routingToIndentData.routingToCancelIndentModel(ele);
                }}
              >
                Cancel
              </div>
            )}
            <div
              className="action-button actionDspan"
              onClick={() => {
                routingToIndentData.routingToIndentDataModel(ele);
              }}
            >
              Details
            </div>
          </div>
        </div>
      );
    case "Assigned":
      return (
        <div className="dropdown">
          <Button className="iconButtons dropbtn actionButtonsDark">
            <img
              style={{ margin: "-4px" }}
              src={actionVerticleDots}
              alt="actions"
            />
          </Button>
          <div className="dropdown-content contentDark">
            {/* <div className="action-button">Edit Details</div> */}
            <div
              className="action-button actionDspan"
              onClick={() => {
                routingToIndentData.routingToIndentDataModel(ele);
              }}
            >
              {" "}
              Details
            </div>
            {canCancel && (
              <div
                className="action-button-cancel"
                onClick={() => {
                  routingToIndentData.routingToCancelIndentModel(ele);
                }}
              >
                Cancel
              </div>
            )}
          </div>
        </div>
      );
    case "Reassigned":
      return (
        <div className="dropdown">
          <Button className="iconButtons dropbtn actionButtonsDark">
            <img
              style={{ margin: "-4px" }}
              src={actionVerticleDots}
              alt="actions"
            />
          </Button>
          <div className="dropdown-content contentDark">
            <div
              className="action-button actionDspan"
              onClick={() => {
                routingToIndentData.routingToIndentDataModel(ele);
              }}
            >
              {" "}
              Details
            </div>
            {canCancel && (
              <div
                className="action-button-cancel"
                onClick={() => {
                  routingToIndentData.routingToCancelIndentModel(ele);
                }}
              >
                Cancel
              </div>
            )}
          </div>
        </div>
      );
    case "Finalized":
      return (
        <div className="dropdown">
          <Button className="iconButtons dropbtn actionButtonsDark">
            <img
              style={{ margin: "-4px" }}
              src={actionVerticleDots}
              alt="actions"
            />
          </Button>
          <div className="dropdown-content contentDark">
            <div
              className="action-button actionDspan"
              onClick={() => {
                routingToIndentData.routingToIndentDataModel(ele);
              }}
            >
              Details
            </div>
            {canCancel && (
              <div
                className="action-button-cancel"
                onClick={() => {
                  routingToIndentData.routingToCancelIndentModel(ele);
                }}
              >
                Cancel
              </div>
            )}
          </div>
        </div>
      );
    case "Expired":
      return (
        <div className="dropdown">
          <Button className="iconButtons dropbtn actionButtonsDark">
            <img
              style={{ margin: "-4px" }}
              src={actionVerticleDots}
              alt="actions"
            />
          </Button>
          <div className="dropdown-content contentDark">
            <div
              className="action-button actionDspan"
              onClick={() => {
                routingToIndentData.routingToIndentDataModel(ele);
              }}
            >
              Details
            </div>
          </div>
        </div>
      );
    case "Cancelled":
      return (
        <div className="dropdown">
          <Button className="iconButtons dropbtn actionButtonsDark">
            <img
              style={{ margin: "-4px" }}
              src={actionVerticleDots}
              alt="actions"
            />
          </Button>
          <div className="dropdown-content contentDark">
            <div
              className="action-button actionDspan"
              onClick={() => {
                routingToIndentData.routingToIndentDataModel(ele);
              }}
            >
              Details
            </div>
          </div>
        </div>
      );
    default:
      return (
        <div className="dropdown">
          <Button className="iconButtons dropbtn actionButtonsDark">
            <img
              style={{ margin: "-4px" }}
              src={actionVerticleDots}
              alt="actions"
            />
          </Button>
          <div className="dropdown-content contentDark">
            <div className="disabled">No Options Available</div>
          </div>
        </div>
      );
  }
};
